import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
// eslint-disable-next-line no-duplicate-imports
import axios from 'axios'
// import { createAuthRefresh } from 'axios-auth-refresh'

// import { postApiAuthRefresh } from './generated/api'

/**
 * Subset of AxiosRequestConfig
 */
export type RequestConfig<TData = unknown> = {
    url?: string
    method: 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE'
    params?: unknown
    data?: TData | FormData
    responseType?: 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream'
    signal?: AbortSignal
    headers?: AxiosRequestConfig['headers']
}
/**
 * Subset of AxiosResponse
 */
export type ResponseConfig<TData = unknown> = {
    data: TData
    status: number
    statusText: string
    headers?: AxiosResponse['headers']
}

export type ResponseErrorConfig<TError = unknown> = TError

export const AXIOS_INSTANCE = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
})

export type Client = <TData, _TError = unknown, TVariables = unknown>(
    config: RequestConfig<TVariables>
) => Promise<ResponseConfig<TData>>

export const client = async <TData, TError = unknown, TVariables = unknown>(
    config: RequestConfig<TVariables>
): Promise<ResponseConfig<TData>> => {
    const promise = AXIOS_INSTANCE.request<TVariables, ResponseConfig<TData>>({ ...config }).catch(
        (error: AxiosError<TError>) => {
            throw error
        }
    )

    return promise
}

// const refreshAuthLogic = async (failedRequest: any) => {
//     try {
//         const { access_token } = await postApiAuthRefresh({
//             Cookie: '',
//         })

//         if (access_token) {
//             localStorage.setItem('@barbershop/admin/auth', access_token)
//             failedRequest.response.config.headers.Authorization = `Bearer ${access_token}`

//             return Promise.resolve()
//         }

//         return Promise.reject()
//     } catch {
//         AXIOS_INSTANCE.defaults.headers.Authorization = ''
//         localStorage.removeItem('@barbershop/admin/auth')

//         return Promise.reject()
//     }
// }

// createAuthRefresh(axios, refreshAuthLogic, {
//     interceptNetworkError: false,
//     statusCodes: [401],
// })

export default client
